import { render, staticRenderFns } from "./ProviderMail.vue?vue&type=template&id=68b2cc7b&lang=pug&"
import script from "./ProviderMail.vue?vue&type=script&lang=js&"
export * from "./ProviderMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports